import api from '../lib/api';

export const FETCH_ROUTE_BY_ID = 'FETCH_ROUTE_BY_ID';
export const FETCH_ROUTES_BY_RIDES = 'FETCH_ROUTES_BY_RIDES';
export const IS_LOADING = 'IS_LOADING';
export const HEATMAP_IS_LOADING = 'HEATMAP_IS_LOADING';
export const CLEAR_HEAT_MAP_DATA = 'CLEAR_HEAT_MAP_DATA';

export default {
  fetchRouteById(routeId) {
    return (dispatch) => {
      dispatch({ type: IS_LOADING, payload: true });

      return api.getRouteById(routeId)
        .then((route) => {
          dispatch({ type: FETCH_ROUTE_BY_ID, payload: route });
        })
        .then(() => {
          dispatch({ type: IS_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: IS_LOADING, payload: false });
        });
    };
  },
  clearHeatMapData() {
    return (dispatch) => {
      dispatch({ type: CLEAR_HEAT_MAP_DATA, payload: true });
    };
  },
  preLoadRoutesForRides() {
    return (dispatch) => dispatch({ type: HEATMAP_IS_LOADING, payload: true });
  },
  fetchRoutesForRides(rideIds) {
    return (dispatch) => {
      dispatch({ type: HEATMAP_IS_LOADING, payload: true });

      return api.getRoutesForRides(rideIds)
        .then((route) => {
          dispatch({ type: FETCH_ROUTES_BY_RIDES, payload: route });
        })
        .then(() => {
          dispatch({ type: HEATMAP_IS_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: HEATMAP_IS_LOADING, payload: false });
        });
    };
  },
};
